import React from "react";
import styled from "styled-components";

const Wrapper = styled.div<{
  $isFullWidth?: boolean;
  $isFullHeight?: boolean;
  $transparent?: boolean;
}>`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
  background: ${(props) => (props.$transparent ? "transparent" : "white")};
  border-radius: 8px;
  box-shadow: ${(props) =>
    props.$transparent ? "none" : "0 4px 10px rgba(0, 0, 0, 0.1)"};
  width: ${(props) => (props.$isFullWidth ? "100%" : "auto")};
  height: ${(props) => (props.$isFullHeight ? "100%" : "auto")};
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
`;

const Header = styled.div`
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
`;

const Content = styled.div`
  padding: 15px;
  width: 90%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  padding-right: 18px;
  cursor: pointer;
`;
const Title = styled.div`
  font-size: 1.2rem;
  padding: 1rem 0 0.5rem 0;
  color: var(--tertiary-font-color);
  font-family: Georgia, serif;
`;

interface Props {
  name: string;
  title?: string;
  content: React.ReactNode;
  isFullWidth?: boolean;
  isFullHeight?: boolean;
  transparent?: boolean;
  onClose?: () => void;
}

const Modal: React.FC<Props> = ({
  name,
  title,
  content,
  onClose,
  transparent,
  isFullWidth,
  isFullHeight,
}) => {
  return (
    <Wrapper
      id={name}
      $isFullWidth={isFullWidth}
      $isFullHeight={isFullHeight}
      $transparent={transparent}
    >
      {title && onClose && (
        <Header>
          {title && <Title>{title}</Title>}
          {onClose && <CloseButton onClick={onClose}>&times;</CloseButton>}
        </Header>
      )}
      <Content>{content}</Content>
    </Wrapper>
  );
};

export default Modal;
